import Icon from '@forwardflow/ui/Icons'
import { message } from 'antd'
import { AssistantsListItem } from '../AssistantsListItem'

import { useParams } from 'react-router-dom'
import { useGetActiveLeadSourceDetails } from '@forwardflow/hooks/customHooks/campaign'

import CampaignService from '@forwardflow/services/CampaignService'

interface AssistantsListProps {
   edit: boolean
}

export const AssistantsList: React.FC<AssistantsListProps> = ({ edit }) => {
   const { title } = useParams()

   const { data: LeadSource, mutate } = useGetActiveLeadSourceDetails(
      title as string
   )

   const onRemoveCampaignAssistant = async (assistantId: number) => {
      try {
         const currentData = { ...LeadSource?.data }
         if (currentData.aiAssistants) {
            currentData.aiAssistants = currentData.aiAssistants.filter(
               (assistant) => assistant.id !== assistantId
            )
            mutate()
         }

         await CampaignService.removeCampaignAssistant(
            assistantId as number,
            title as string
         )
         message.success('Assistant removed successfully')
      } catch (error) {
         console.error('Failed to remove assistant:', error)
         message.error('Failed to remove assistant')
      } finally {
         mutate()
      }
   }

   return (
      <div>
         <div className="mb-1 bg-primary/10">
            <div className="flex items-center px-10 py-5 font-medium bg-primary/10">
               <Icon name="Persona" className="mr-4 fill-white" />
               <span>{LeadSource?.data?.aiAssistants?.length}</span>
            </div>
            {LeadSource && (
               <p className="text-[12px] text-[#B98BE6]/70 px-10 py-5">
                  We have created {LeadSource?.data?.aiAssistants?.length}{' '}
                  agents with {LeadSource?.data?.aiAssistants?.length} different
                  voices for this campaign, you can add more using the slider.
               </p>
            )}
         </div>

         <div className="flex flex-col gap-2 mb-2">
            {Array.isArray(LeadSource?.data?.aiAssistants) &&
               LeadSource?.data?.aiAssistants?.map((assistant, index) => (
                  <AssistantsListItem
                     title={title as string}
                     isEdited={edit}
                     voice_id={assistant?.voiceId}
                     key={index}
                     assistant_id={assistant?.id}
                     name={assistant?.assistantName}
                     designation={assistant.designation}
                     gender={assistant.gender}
                     description={assistant.description}
                     avatar={assistant.avatar as string}
                     accent={assistant.accent}
                     onRemoveCampaignAssistant={() =>
                        onRemoveCampaignAssistant(assistant?.id)
                     }
                  />
               ))}
         </div>
      </div>
   )
}
